import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyFetchMarketsResult = objectOf({
  markets: arrayOf(
    objectOf({
      id: string,
      name: string,
      handle: string,
      catalog_id: maybe(string, true),
      countries: arrayOf(
        objectOf({
          code: string,
          name: string,
        })
      ),
      default_locale: maybe(string, true),
      locales: maybe(arrayOf(string), true),
      currency_code: maybe(string, true),
      root_urls: maybe(
        arrayOf(
          objectOf({
            locale: string,
            url: string,
          })
        ),
        true
      ),
    })
  ),
});
